<template>
  <div id="app">
    <layout-login v-if="this.$route.name == 'login'" />
    <layout-default v-if="this.$route.name != 'login'" />
  </div>
</template>
<script>


    import LayoutDefault from "@/layout/default";
    import LayoutLogin from "@/layout/login";

    export default {
        name: 'App',
        components: {LayoutLogin, LayoutDefault},
    }
</script>
<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
